export const JOURNAL_VOUCHER_REPORT_REQUEST = 'JOURNAL_VOUCHER_REPORT_REQUEST';
export const JOURNAL_VOUCHER_REPORT_SUCCESS = 'JOURNAL_VOUCHER_REPORT_SUCCESS';
export const JOURNAL_VOUCHER_REPORT_FAILURE = 'JOURNAL_VOUCHER_REPORT_FAILURE';